/*============================================================================
Quantity Product Box on Mobile
==============================================================================*/
(function(i){var e=/iPhone/i,n=/iPod/i,o=/iPad/i,t=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,r=/Android/i,d=/BlackBerry/i,s=/Opera Mini/i,a=/IEMobile/i,b=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,h=RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),c=function(i,e){return i.test(e)},l=function(i){var l=i||navigator.userAgent;this.apple={phone:c(e,l),ipod:c(n,l),tablet:c(o,l),device:c(e,l)||c(n,l)||c(o,l)},this.android={phone:c(t,l),tablet:!c(t,l)&&c(r,l),device:c(t,l)||c(r,l)},this.other={blackberry:c(d,l),opera:c(s,l),windows:c(a,l),firefox:c(b,l),device:c(d,l)||c(s,l)||c(a,l)||c(b,l)},this.seven_inch=c(h,l),this.any=this.apple.device||this.android.device||this.other.device||this.seven_inch},v=i.isMobile=new l;v.Class=l})(window);

if (isMobile.android.phone ||
    isMobile.apple.phone ||
    isMobile.apple.ipod ||
    isMobile.other.opera ||
    isMobile.other.firefox ||
    isMobile.other.blackberry ) { //inside the mobile function
        $('.template-product .quantity-selector').css('padding-top', '8px').css('padding-bottom', '5px').css('padding-left', '11px').css('padding-right', '11px');
}


/*============================================================================
Show Collection Image in Nav
==============================================================================*/
function navImageAnimation() {
    var timeClear = null;
    if ( $(window).width() >= 1385 ) {
        for ( var i = 1; i < 10; i++ ) {
            var imageContainer = '.image-li-container-' + i;
            $(imageContainer).each(function() {
                $(this).hover(function() {
                  	if(timeClear){
                    	clearTimeout(timeClear);
                  	}
                    $('.nav-bar').addClass('nav-bar-hover');
                    $('.border-bottom-container').addClass('border-bottom-container-hover');
                    $(this).children().first().toggleClass('collection-link-container-hover');
                    $(this).siblings().removeClass('link-image-show');
                    $(this).next().addClass('link-image-show');
                });
                $(this).mouseleave(function() {
                    $(this).next().removeClass('link-image-show');
                    $('.border-bottom-container').removeClass('border-bottom-container-hover');
                      timeClear = setTimeout(
                        function(){
                          $('.nav-bar').removeClass('nav-bar-hover');
                        }, 333);
                });
                if ( imageContainer == '.image-li-container-3') {
                    $(this).hover(function() {
                        $('.link-text-container-3').css('display', 'inline-block');
                    });
                    $(this).mouseleave(function() {
                        $('.link-text-container-3').css('display', 'none');
                    });
                };
            });
        };
    } else {
        for ( var i = 1; i < 10; i++ ) {
            var imageContainer = '.image-li-container-' + i;
            $(imageContainer).each(function() {
                $(this).hover(function() {
                    $('.nav-bar').removeClass('nav-bar-hover');
                    $(this).children().first().removeClass('collection-link-container-hover');
                    $(this).siblings().removeClass('link-image-show');
                });
                if ( imageContainer == '.image-li-container-3') {
                    $(this).hover(function() {
                        $('.link-text-container-3').css('display', 'none');
                    });
                };
            });
        };
    }
}

navImageAnimation();

$(window).on('resize', function() {
    navImageAnimation();
});


/*============================================================================
 Nav fade in
==============================================================================*/
$(document).ready(function() {
    window.setTimeout(function() {
        $('.template-index .nav-bar').css('opacity', '1');
    }, 1000);
});


/*============================================================================
 Instagram Plugin // Spectragram
==============================================================================*/
jQuery.fn.spectragram.accessData = {
    accessToken: '2805214429.25581f6.ed0f4165b18e4b61acf1c9c89872d52c',
    clientID: '25581f62a3ab421b8edbcaa3ff2c1f40 '
};

$('#instagram').spectragram('getUserFeed',{
    query: 'bisonunion',
    max: 6,
    wrapEachWith: '<div class="instagram-image-container grid__item small--one-half medium--one-third large--one-sixth position-relative"></div>'
});

$(window).on('load',function(){
    instagram_image_background();
});

instagram_image_background = function() {
    $(".instagram-image-container img").each(function(i, elem) {
      var img = $(elem);
      var div = $("<div />").css({
        background: "url(" + img.attr("src") + ") no-repeat center center / cover",
        width: img.width() + "px",
        height: img.height() + "px"
      });

      if ( img.height() <= 261 ) {
          div.css({
              width: img.width() + 57 + "px",
              height: img.height() + 57 + "px"
          });
      };

      div.html(img.attr("alt"));

      img.replaceWith(div);
    });

    $('.instagram-image-container div').each(function(){
        $(this).html("");
    });

    $('.instagram-image-container a').append('<div class="instagram-overlay-container"><div class="position-relative"><span class="instagram-info-container"><i class="fa fa-instagram"></i><p class="instagram-caption"></p></span></div></div>');

    window.setTimeout(function(){
        $('.instagram-container').css('opacity', '1');
    }, 500);

    $('.instagram-overlay-container').each(function() {
        var titleText = $(this).parent().attr('title');
        $(this).children().children().children().last().html(titleText);
        $(this).hover(function() {
            $(this).children().children().toggle();
        });
    });
};


/*============================================================================
Hover Effect on 'From The Blog'
==============================================================================*/
$('.blog-link-a').each(function(){
    $(this).hover(function(){
        $(this).next().toggleClass('hover-effect');
    });
});


/*============================================================================
Equal Height Divs
==============================================================================*/
/* Thanks to CSS Tricks for pointing out this bit of jQuery
http://css-tricks.com/equal-height-blocks-in-rows/
It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */

equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
};


$(window).load(function() {
  equalheight('.same_height');
});

$(window).resize(function(){
  equalheight('.same_height');
});

/*============================================================================
Hero Slick Carousel
==============================================================================*/
$('#Hero').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    nextArrow: '#slideshow .arrows-container .right',
    prevArrow: '#slideshow .arrows-container .left'
});


/*============================================================================
Testimonials Slick Carousel
==============================================================================*/
$('#testimonial-hero').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    nextArrow: '#testimonials .arrows-container .right',
    prevArrow: '#testimonials .arrows-container .left'
});


/*============================================================================
Home Page Collection Slick Carousel
==============================================================================*/
/*
$('#collection-grid').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: '#shopify-section-1513811742073 .arrows-container .right',
    prevArrow: '#shopify-section-1513811742073 .arrows-container .left',
    responsive: [
    {
       breakpoint: 1100,
       settings: {
           slidesToShow: 4,
       }
    },
    {
       breakpoint: 1090,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});
*/


/*============================================================================
Related Products Carousel
==============================================================================*/
$('.related-products-carousel-container .container').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: '.fa-caret-right',
    prevArrow: '.fa-caret-left',
    responsive: [
    {
       breakpoint: 1160,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});


/*============================================================================
Featured Products Carousel
==============================================================================
$('#CollectionSection .container').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: '.fa-caret-right',
    prevArrow: '.fa-caret-left',
    responsive: [
    {
       breakpoint: 1100,
       settings: {
           slidesToShow: 4,
       }
    },
    {
       breakpoint: 1090,
       settings: {
           slidesToShow: 3,
       }
    },
    {
       breakpoint: 900,
       settings: {
           slidesToShow: 2,
       }
    },
   {
       breakpoint: 640,
       settings: {
           slidesToShow: 1,
       }
   }
 ]
});
*/


/*============================================================================
Tabs on Product page
==============================================================================*/
$(document).ready(function() {
    $('ul.tabs').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
            $($(this).attr('href')).hide();
        });

        $(this).find('a').click(function(e){
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return false;
        });
    });
});


/*============================================================================
First select option on product varies disabled - Edited by Wes 08/29/22
==============================================================================*/
$(document).ready(function() {

    // If Add To Cart is clicked, check if any selector is set to 'Select' and prevent from firing if true
    $("#AddToCart").on('click', function(e){
        $.each($("div.product-single select[id^='productSelect-option']"), function(index, value) {
            var selector = $(this);

            if (selector.val() == 'Select') {
                e.preventDefault();
                //If 'Select' on product is selected, 'Add To Cart' button says 'Pick Variant'
                $('#AddToCartText').text('Add to Cart');
            };
        });
    });

    // If the option is 'Select', then the AddToCartText changes to 'Pick Variant'
    $("div.product-single select[id^='productSelect-option']").on('change', function(){
        var $self = $(this);
        if ($self.val() === 'Select'){ 
          $('#AddToCartText').text('Add to Cart');
          $('#BIS_trigger').css('display', 'none');
        }
        if($("div.product-single select[id^='productSelect-option']").val() === 'Select'){
          $('#AddToCartText').text('Add to Cart');
          $('#BIS_trigger').css('display', 'none');
        }
    });


    // Enable/Disable the visual display of add to cart
    window.setTimeout(function(){

        // Find all Selectors and add dropdown option for 'Select'
        $.each($("div.product-single select[id^='productSelect-option']"), function(index, value) {
            var selector = $(this);
            if ( selector.hasClass('single-option-selector') && selector.is(":visible") || ( selector.hasClass('single-option-selector')) ) {
                var option = document.createElement('option');
                option.value = 'Select';
                option.innerHTML = 'Select';
                option.name = 'default';
                $(selector).prepend(option);
                $(selector).val('Select');
            };
        });

        $.each($("div.product-single select[id^='productSelect-option']"), function(index, value) {
            var selector = $(this);
            if ( selector.val() == 'Select' ) {
                $('#AddToCart').addClass('disabled');
                //If 'Select' on product is selected, 'Add To Cart' button says 'Pick a Style'
                $('#AddToCartText').text('Add to Cart');
            } else {
                if ( $('#AddToCart').hasClass('disabled') ) {
                    $('#AddToCart').removeClass('disabled');
                };
            };
        });

    }, 250);

});